import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../shared/providers/common.service';
import { AuditTrailDetailModel } from '../../shared/models/AuditTrailDetailModel';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';

@Component({
    selector: 'app-audit-trail-details',
    templateUrl: './audit-trail-details.component.html'
})
export class AuditTrailDetailsComponent implements OnInit {

    constructor(private _commonService: CommonService) { }

    @Input() auditTrailId: number;
    @Input() modalRef: BsModalRef;
    ngOnInit() {
        this.loadAuditTrailDetailData(this.auditTrailId);
    }
    auditTrailDetailModel: AuditTrailDetailModel[];
    showNoChangeText = false;
    loadAuditTrailDetailData(Id) {
        this._commonService.GetAuditTrailDetailList(Id).subscribe(response => {
            if (response != null) {
                this.auditTrailDetailModel = response;
                if (this.auditTrailDetailModel.length > 0) {
                    if (this.auditTrailDetailModel[0].Id == 0) {
                        this.showNoChangeText = true;
                  }
                  this.auditTrailDetailModel.forEach(item => {
                    if (item.FieldName == 'Offer Date' || item.FieldName == 'Created Date') {
                      var localTime = moment.utc(item.ChangedValue).toDate();
                      item.ChangedValue = moment(localTime).format('MM/DD/YYYY HH:mm:ss');
                      if (item.PreviousValue != "" && item.PreviousValue != null) {
                        var prevLocalTime = moment.utc(item.PreviousValue).toDate();
                        item.PreviousValue = moment(prevLocalTime).format('MM/DD/YYYY HH:mm:ss');
                      }
                    }
                  });
                }
            }
        });
    }
}
